'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _registration = require('redux/actions/registration');

var _error = require('redux/actions/error');

var _constants = require('components/Registration/constants');

var _Registration = require('components/Registration');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Registration: {
        displayName: 'Registration'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Registration/Registration.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Registration = _wrapComponent('Registration')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        regError: state.registration.errorsList,
        preload: state.registration.preload,
        step: state.registration.step,
        user: state.auth.user
    };
}, {
    confirmRegistration: _registration.confirmRegistration,
    error: _error.error,
    pushState: _reactRouterRedux.push,
    registration: _registration.registration,
    resetStep: _registration.resetStep
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Registration, _Component);

    function Registration(props) {
        (0, _classCallCheck3.default)(this, Registration);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Registration.__proto__ || (0, _getPrototypeOf2.default)(Registration)).call(this, props));

        _this.changeFields = function (newState) {
            // if (newState.hasOwnProperty('phone')) {
            //     this.setState({phone: newState.phone});
            // }
            if (newState.hasOwnProperty('password')) {
                _this.setState({ password: newState.password });
            }
        };

        _this.updateFormData = function (formData) {
            _this.setState(function (prevState) {
                return (0, _extends3.default)({}, prevState, formData);
            });
        };

        _this.renderComponent = function () {
            switch (_this.props.step) {
                case _constants.REGISTRATION_STEP_CONFIRMED:
                    return _react3.default.createElement(_Registration.RegistrationConfirm, {
                        changeField: _this.changeFields,
                        formData: _this.state
                    });
                    break;

                case _constants.REGISTRATION_STEP_CONFIRMED_SUCCESS:
                    return _react3.default.createElement(_Registration.RegistrationSuccess, {
                        formData: _this.state
                    });
                    break;

                case _constants.REGISTRATION_STEP_FORM:
                default:
                    return _react3.default.createElement(_Registration.RegistrationForm, {
                        onChange: _this.changeFields,
                        updateFormData: _this.updateFormData
                    });
                    break;
            }
        };

        _this.state = {
            password: ''
        };

        _this.initialState = _this.state;
        return _this;
    }

    (0, _createClass3.default)(Registration, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.user) {
                this.props.pushState('/');
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetStep();
        }

        /**
         * Обработчик обновления состояния для его передачи в другие компоненты
         * @param formData
         */

    }, {
        key: 'render',
        value: function render() {
            return _react3.default.createElement(
                'div',
                null,
                this.renderComponent()
            );
        }
    }]);
    return Registration;
}(_react2.Component), _class2.propTypes = {
    confirmRegistration: _react2.PropTypes.func.isRequired,
    error: _react2.PropTypes.func.isRequired,
    pushState: _react2.PropTypes.func.isRequired,
    registration: _react2.PropTypes.func.isRequired,
    resetStep: _react2.PropTypes.func.isRequired,
    step: _react2.PropTypes.string.isRequired,
    user: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = Registration;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/Registration.jsx
// module id = 1745
// module chunks = 0